import { Breadcrumbs } from './index.jsx';

const PlaceholderBreadCrumbs = (props) => <Breadcrumbs.Skeleton {...props} />;

export default PlaceholderBreadCrumbs;
